import { SuperThemeMode } from '../types';
export var getSuperThemeMode = function (themeMode) {
    return themeMode.includes('light') ? SuperThemeMode.LIGHT : SuperThemeMode.DARK;
};
